import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from './ui/card';
import { Clock, DollarSign, Sparkles } from 'lucide-react';

const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-24 bg-stone-50 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-rose-100/30 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-stone-100 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-rose-400 text-sm tracking-widest uppercase font-medium">
            Services
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-800 mt-3 mb-4">
            {t.services.title}
          </h2>
          <div className="w-16 h-1 bg-rose-300 mx-auto mb-6" />
          <p className="text-stone-600 text-lg">{t.services.subtitle}</p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.services.items.map((service, index) => (
            <Card
              key={service.id}
              className="group bg-white border-0 shadow-sm hover:shadow-xl transition-all duration-500 overflow-hidden"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <CardContent className="p-8">
                {/* Service Number */}
                <div className="flex items-center justify-between mb-6">
                  <span className="text-6xl font-serif text-stone-100 group-hover:text-rose-100 transition-colors">
                    0{index + 1}
                  </span>
                  <Sparkles className="w-6 h-6 text-rose-300 opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>

                {/* Service Name */}
                <h3 className="text-xl font-medium text-stone-800 mb-3 group-hover:text-rose-500 transition-colors">
                  {service.name}
                </h3>

                {/* Description */}
                <p className="text-stone-500 text-sm leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Price & Duration */}
                <div className="flex items-center justify-between pt-4 border-t border-stone-100">
                  <div className="flex items-center gap-2 text-stone-600">
                    <DollarSign className="w-4 h-4 text-rose-400" />
                    <span className="text-sm font-medium">{service.price}</span>
                  </div>
                  <div className="flex items-center gap-2 text-stone-500">
                    <Clock className="w-4 h-4 text-rose-400" />
                    <span className="text-sm">{service.duration}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
